module.exports = __webpack_public_path__ + "img/header-diamondJewelryRedgold.ef3a587.jpg";